import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";

import QuinCardSection from "./QuinCardSection";
import QuinItemEdit from "./QuinItemEdit";
import QuinItemAdd from "./QuinItemAdd";
import { selectActiveUid } from "../Auth/authSlice";
import { setQuinIndexData } from "./quinIndexSlice";
import {
  getKinshasaDateTime,
  getKinshasaTime,
} from "../../utils/getKinshasaDateTime";
import { db } from "../../config/firebaseConfig";
import { doc, setDoc } from "firebase/firestore";
import MyDatePicker from "../../components/CardSection/MyDatePicker";
import { isoToFrDmy } from "../../utils/dateUtils";

const QuinIndex = () => {
  const listPump = [
    { label: "S1", value: "S1" },
    { label: "S2", value: "S2" },
    { label: "S3", value: "S3" },
    { label: "S4", value: "S4" },
    { label: "S5", value: "S5" },
    { label: "S6", value: "S6" },
    { label: "G1", value: "G1" },
    { label: "G2", value: "G2" },
    { label: "G3", value: "G3" },
    { label: "G4", value: "G4" },
  ];

  const [index, setIndex] = useState();
  const [loading, setLoading] = useState(false);
  const myQuinIndexStore = useSelector((state) => state.quinIndex);
  const [selectedPump, setSelectedPump] = useState("");
  const [cardOpen, setCardOpen] = useState(false);
  const [livraisonOpen, setLivraisonOpen] = useState(false);
  const [venteName, setVenteName] = useState("");
  const [livraisonName, setLivraisonName] = useState("");
  const todayIso = () => new Date().toISOString().slice(0, 10);
  const [venteDate, setVenteDate] = useState(todayIso);
  const [livraisonDate, setLivraisonDate] = useState(todayIso);
  const dispatch = useDispatch();
  const activeUid = useSelector(selectActiveUid);
  const isAdmin = useSelector((state) => state.auth.isAdmin);

  const handleSelectedPumpChange = (event) => {
    setSelectedPump(event.target.value);
  };

  const handleChangeIndex = (event) => {
    setIndex(event.target.value);
  };

  const handleAdd = () => {
    if (!selectedPump || !index) return;

    const date = getKinshasaDateTime();
    dispatch(
      setQuinIndexData({
        type: "INDEX",
        item: selectedPump,
        value: index,
        date: date,
      }),
    );
    setSelectedPump("");
    setIndex("");
  };

  const onVenteClick = async (e, cartItems) => {
    e.stopPropagation();
    if (!cartItems || cartItems.length === 0) return;
    setLoading(true);
    const docDate = isoToFrDmy(venteDate);
    const time = getKinshasaTime().replace(/:/g, "_");
    const key = `VENTE_${time}`;
    const payload = {
      [key]: {
        type: "VENTE",
        items: cartItems,
        total: cartItems.reduce((sum, item) => sum + item.tot, 0),
        date: getKinshasaDateTime(),
        name: venteName.trim(),
      },
    };
    try {
      const docRef = doc(db, "users", activeUid, "data_quin", docDate);
      await setDoc(docRef, payload, { merge: true });
      setVenteName("");
      setCardOpen(false);
    } catch (e) {
      console.error("Error adding VENTE document: ", e);
    }
    setLoading(false);
  };

  const onLivraisonClick = async (e, cartItems) => {
    e.stopPropagation();
    if (!cartItems || cartItems.length === 0) return;
    setLoading(true);
    const docDate = isoToFrDmy(livraisonDate);
    const time = getKinshasaTime().replace(/:/g, "_");
    const key = `LIVR_${time}`;
    const payload = {
      [key]: {
        type: "LIVRAISON",
        items: cartItems.map(({ id, article, qte }) => ({ id, article, qte })),
        date: getKinshasaDateTime(),
        name: livraisonName.trim(),
      },
    };
    try {
      const docRef = doc(db, "users", activeUid, "data_quin", docDate);
      await setDoc(docRef, payload, { merge: true });
      setLivraisonName("");
      setLivraisonOpen(false);
    } catch (e) {
      console.error("Error adding LIVRAISON document: ", e);
    }
    setLoading(false);
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 32,
      }}
    >
      <CircularProgress color="primary" size={48} />
      <div style={{ marginTop: 16, fontSize: 18 }}>Chargement...</div>
    </div>
  ) : (
    <>
      <QuinCardSection
        title="VENTE"
        myStore={myQuinIndexStore.index}
        listItem={listPump}
        handleSelectedItemChange={handleSelectedPumpChange}
        selectedItem={selectedPump}
        handleChangeValue={handleChangeIndex}
        handleAdd={handleAdd}
        selectedValue={index}
        onClick={onVenteClick}
        open={cardOpen}
        setOpen={setCardOpen}
        nameValue={venteName}
        onNameChange={(e) => setVenteName(e.target.value)}
      >
        <MyDatePicker value={venteDate} onChange={(e) => setVenteDate(e.target.value)} />
      </QuinCardSection>
      <QuinCardSection
        title="LIVRAISON"
        showPrice={false}
        myStore={myQuinIndexStore.index}
        listItem={listPump}
        handleSelectedItemChange={handleSelectedPumpChange}
        selectedItem={selectedPump}
        handleChangeValue={handleChangeIndex}
        handleAdd={handleAdd}
        selectedValue={index}
        onClick={onLivraisonClick}
        open={livraisonOpen}
        setOpen={setLivraisonOpen}
        nameValue={livraisonName}
        onNameChange={(e) => setLivraisonName(e.target.value)}
      >
        <MyDatePicker value={livraisonDate} onChange={(e) => setLivraisonDate(e.target.value)} />
      </QuinCardSection>
      {isAdmin && (
        <>
          <QuinItemEdit />
          <QuinItemAdd />
        </>
      )}
    </>
  );
};

export default QuinIndex;
